import _ from 'underscore';
import classnames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';

import { Carousel } from '@bingads-webui-react/primitive-unthemed';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
// import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { getImgExtBingMobileMultiImage133x100Styles } from '../../styles';
import {
  MMAPlacementCard,
  PlacementHeadline,
  PlacementFinalUrl,
  PlacementDescription,
  AdLabel,
} from '../../shared-components';

// multi-image placement
const BingMobileMultiImage133x100 = ({
  placementData, // UAPVMPlacement
  isEnabled,
  longHeadline,
  finalUrl,
  description,
  i18n,
  classes,
}) => {
  //
  const [carouselState, setCarouselState] = useState({ index: 0, direction: null });

  const { placementMeta, images = [] } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};

  // there are 4 images in the placement, the last 3 are placeholder images
  const imagesWithPadding = useMemo(
    () => [0, 1, 2, 3].map(index => (images && images[index]) || _.last(images)),
    [images]
  );

  // const srcForCroppedImageView = showImage && this.props.image.FinalSrc;
  const imagePreviewWidth = previewHeight * aspectRatio;

  const handleSelect = useCallback((selectedIndex, e) => {
    setCarouselState({
      index: selectedIndex,
      direction: e.direction,
    });
  }, []);

  if (!placementData || !placementMeta || _.isEmpty(images)) {
    return null;
  }

  return (
    <MMAPlacementCard width={imagePreviewWidth} isEnabled={isEnabled} mmaPlacementCardClassName={classes.placementCard}>
      <div className={classnames(classes.placementImageContainer)}>
        <Carousel
          activeIndex={carouselState.index}
          direction={carouselState.direction}
          onSelect={handleSelect}
          controls={false}
          wrap={false}
          className="multi-image-placement-carousel"
        >
          {
            imagesWithPadding.map(({
              imageMeta, placementCropping, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
            }, idx) => {
              const cropping = expandedPlacementCropping || placementCropping;
              return (
                <Carousel.Item key={`${imageMeta.id || idx}`}>
                  <AdLabel adsLabelClassName={classes.placementAdsLabel} i18n={i18n} />
                  <CroppedImageView
                    resizeImageHeight={previewHeight}
                    aspectRatio={aspectRatio}
                    src={effectiveImageUrl || imageMeta.url}
                    originalWidth={effectiveImageWidth || imageMeta.originalWidth}
                    originalHeight={effectiveImageHeight || imageMeta.originalHeight}
                    SourceX={cropping && cropping.SourceX}
                    SourceY={cropping && cropping.SourceY}
                    SourceWidth={cropping && cropping.SourceWidth}
                    SourceHeight={cropping && cropping.SourceHeight}
                  />
                </Carousel.Item>);
            })
          }
        </Carousel>
      </div>
      <div className={classnames(classes.placementTextContainer)}>
        <PlacementHeadline
          headlineText={longHeadline}
          isMultiLine
          placementHeadlineClassName={classnames(classes.placementLongHeadline, 'long-headline')}
        />
        <PlacementFinalUrl
          finalUrl={finalUrl}
          isMultiLine
          placementFinalUrlClassName={classnames(classes.placementFinalUrl, 'final-url')}
        />
        <PlacementDescription
          description={description}
          isMultiLine
          placementDescriptionClassName={classnames(classes.placementDescription, 'description')}
        />
      </div>
    </MMAPlacementCard>
  );
};

export const AdPlacementImgExtBingMobileMultiImage133x100 = withUAPLThemedStyles(
  BingMobileMultiImage133x100,
  getImgExtBingMobileMultiImage133x100Styles,
  { componentName: 'AdPlacementImgExtBingMobileMultiImage133x100' }
);
